/* =========================================================================
   Boil Amsterdam — Likes / Favorieten
   Anonieme wishlist via localStorage. Geen account nodig.
   - Toggle elk element met [data-bil-like-toggle]
   - Render een grid op de favorieten-pagina via [data-bil-likes-grid]
   ========================================================================= */
(function () {
  'use strict';

  var STORAGE_KEY = 'bil:likes';

  /* -------- storage helpers -------- */

  function getLikes() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveLikes(likes) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(likes));
      document.dispatchEvent(new CustomEvent('bil:likes:change', { detail: { likes: likes } }));
    } catch (e) {
      /* localStorage kan disabled zijn (private mode) — stil falen */
    }
  }

  function isLiked(handle) {
    if (!handle) return false;
    return getLikes().some(function (item) { return item.handle === handle; });
  }

  function toggleLike(handle, id) {
    if (!handle) return false;
    var likes = getLikes();
    var index = -1;
    for (var i = 0; i < likes.length; i++) {
      if (likes[i].handle === handle) { index = i; break; }
    }
    if (index > -1) {
      likes.splice(index, 1);
      saveLikes(likes);
      return false;
    }
    likes.push({ handle: handle, id: id || null, addedAt: Date.now() });
    saveLikes(likes);
    return true;
  }

  /* -------- toggle button sync -------- */

  function syncButtons() {
    var buttons = document.querySelectorAll('[data-bil-like-toggle]');
    Array.prototype.forEach.call(buttons, function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var liked = isLiked(handle);
      btn.classList.toggle('is-liked', liked);
      btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
      btn.setAttribute('aria-label', liked ? 'Verwijder uit favorieten' : 'Bewaar in favorieten');
      var label = btn.querySelector('[data-bil-like-label]');
      if (label) label.textContent = liked ? 'Verwijder uit favorieten' : 'Bewaar in favorieten';
    });
    syncCount();
  }

  function syncCount() {
    var count = getLikes().length;
    var nodes = document.querySelectorAll('[data-bil-likes-count]');
    Array.prototype.forEach.call(nodes, function (node) {
      node.textContent = String(count);
      if (count > 0) {
        node.removeAttribute('hidden');
      } else {
        node.setAttribute('hidden', '');
      }
    });
  }

  function handleToggleClick(e) {
    var btn = e.target.closest && e.target.closest('[data-bil-like-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    var id = btn.getAttribute('data-product-id');
    toggleLike(handle, id);
    syncButtons();
  }

  /* -------- favorieten-pagina -------- */

  function formatPrice(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    /* Strip ",00" naar heel-getal weergave (bv. €450 i.p.v. €450,00) */
    if (value.slice(-3) === ',00') value = value.slice(0, -3) + ',-';
    return '€' + value;
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderCard(product) {
    var soldBadge = product.available ? '' :
      '<span class="bil-likes-card__badge">Verhuurd</span>';
    var img = product.featured_image
      ? '<img src="' + escapeHtml(product.featured_image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
      : '';
    return [
      '<div class="bil-likes-card" data-bil-likes-card data-product-handle="' + escapeHtml(product.handle) + '">',
      '  <a href="' + escapeHtml(product.url) + '" class="bil-likes-card__link">',
      '    <div class="bil-likes-card__image-wrap">',
      '      ' + img,
      '      ' + soldBadge,
      '    </div>',
      '    <div class="bil-likes-card__title">' + escapeHtml(product.title) + '</div>',
      '    <div class="bil-likes-card__price">' + formatPrice(product.price) + '</div>',
      '  </a>',
      '  <button type="button" class="bil-likes-card__remove" data-bil-likes-remove ',
      '          data-product-handle="' + escapeHtml(product.handle) + '" ',
      '          aria-label="Verwijder uit favorieten">×</button>',
      '</div>'
    ].join('\n');
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });
  }

  var rendering = false;
  function renderFavoritesGrid() {
    var grid = document.querySelector('[data-bil-likes-grid]');
    if (!grid || rendering) return;
    var empty = document.querySelector('[data-bil-likes-empty]');
    var likes = getLikes();

    if (likes.length === 0) {
      grid.innerHTML = '';
      grid.classList.remove('bil-likes-grid--loading');
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    rendering = true;
    grid.classList.add('bil-likes-grid--loading');

    Promise.all(likes.map(function (l) { return fetchProduct(l.handle); }))
      .then(function (products) {
        var validProducts = products.filter(Boolean);

        /* Verwijder ongeldige handles uit storage zodat ze niet meer verschijnen */
        if (validProducts.length !== likes.length) {
          var validHandles = validProducts.map(function (p) { return p.handle; });
          var cleaned = likes.filter(function (l) { return validHandles.indexOf(l.handle) > -1; });
          if (cleaned.length !== likes.length) {
            try { localStorage.setItem(STORAGE_KEY, JSON.stringify(cleaned)); } catch (e) {}
          }
        }

        if (validProducts.length === 0) {
          grid.innerHTML = '';
          if (empty) empty.hidden = false;
        } else {
          grid.innerHTML = validProducts.map(renderCard).join('');
        }
        grid.classList.remove('bil-likes-grid--loading');
      })
      .catch(function () {
        grid.classList.remove('bil-likes-grid--loading');
      })
      .then(function () { rendering = false; });
  }

  function handleRemoveClick(e) {
    var btn = e.target.closest && e.target.closest('[data-bil-likes-remove]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    var likes = getLikes().filter(function (l) { return l.handle !== handle; });
    saveLikes(likes);
    /* Verwijder de card uit de DOM zodat het direct voelt */
    var card = btn.closest('[data-bil-likes-card]');
    if (card && card.parentNode) card.parentNode.removeChild(card);
    if (getLikes().length === 0) {
      var empty = document.querySelector('[data-bil-likes-empty]');
      if (empty) empty.hidden = false;
    }
    syncButtons();
  }

  /* -------- init -------- */

  function init() {
    syncButtons();
    document.addEventListener('click', function (e) {
      handleToggleClick(e);
      handleRemoveClick(e);
    });
    document.addEventListener('bil:likes:change', function () {
      syncButtons();
    });
    /* Sync tussen tabs */
    window.addEventListener('storage', function (e) {
      if (e.key === STORAGE_KEY) {
        syncButtons();
        renderFavoritesGrid();
      }
    });
    renderFavoritesGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
